<template>
  <v-container no-gutters>
    <template v-if="!isCorrect">
      <v-row no-gutters class="justify-center pb-6">
        <v-col cols="auto">
          <v-subheader class="text-h6 pa-0 font--text font-weight-regular" style="height: auto;">
            {{ $i18n.t('login.createNewPassword') }}
          </v-subheader>
        </v-col>
      </v-row>
      <v-row no-gutters class="justify-center">
        <v-col cols="8" lg="7">
          <v-form lazy-validation v-model="isValid">
            <authentication-input
              translation-path="login.password"
              autofocus
              validate-on-blur
              :rules="[...computedRules, v => !!v || 'rules.required']"
              v-model="credentials.password"
              type="password"
              class="pb-2"
            ></authentication-input>
            <authentication-input
              translation-path="login.repeatPassword"
              :rules="[samePassword]"
              validate-on-blur
              type="password"
              v-model="repeatPassword"
              class="pb-4"
            ></authentication-input>
            <v-row no-gutters class="justify-end">
              <v-col cols="auto">
                <base-button
                  :disabled="!isValid"
                  :loading="isLoading"
                  @click="getResetPasswordLink"
                  translation-path="login.save"
                  style="margin-right: 0px !important;"
                ></base-button>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row no-gutters>
        <v-col cols="9">
          <v-row no-gutters class="justify-end align-center">
            <v-col cols="auto" class="pr-2">
              <v-icon class="success--text">
                mdi-check
              </v-icon>
            </v-col>
            <v-col cols="auto">
              <v-subheader class="text-h6 pa-0 success--text font-weight-regular" style="height: auto;">
                {{ $i18n.t('login.passwordChanged') }}
              </v-subheader>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="9">
          <v-row no-gutters class="justify-end">
            <v-col cols="auto">
              <link-underlined
                translation-path="login.backToLogin"
                @click="$router.push({ name: 'login' })"
              ></link-underlined>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- <v-row no-gutters>

      </v-row> -->
    </template>
  </v-container>
</template>

<script>
import { call } from 'vuex-pathify';
import AuthenticationInput from '@/components/AuthenticationInput';
import LinkUnderlined from '@/components/LinkUnderlined';
import passwordRules from '@/mixins/passwordRules';

export default {
  name: 'Login',
  mixins: [passwordRules],
  components: {
    LinkUnderlined,
    AuthenticationInput,
  },
  props: {
    hash: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    credentials: {
      password: undefined,
    },
    repeatPassword: undefined,
    isValid: true,
    isLoading: false,
    isCorrect: false,
  }),
  computed: {
    samePassword() {
      return this.credentials.password === this.repeatPassword || 'rules.samePassword';
    },
  },
  methods: {
    resetPasswordAction: call('authentication/resetPassword'),
    async getResetPasswordLink() {
      try {
        this.isLoading = true;
        console.log('getResetPasswordLink -> { hash: this.hash, body: this.credentials }', {
          hash: this.hash,
          body: this.credentials,
        });
        await this.resetPasswordAction({ hash: this.hash, body: this.credentials });
        this.isCorrect = true;
        this.isLoading = false;
      } catch (error) {
        console.log(`loginHandler -> error`, error.message);
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
